(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trofeos-medallas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-trofeos-landing]');

    sections.forEach(function (section) {
      var revealTargets = section.querySelectorAll('.trofeos-reveal');
      if ('IntersectionObserver' in window && revealTargets.length) {
        var revealObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );
        revealTargets.forEach(function (el) {
          revealObserver.observe(el);
        });
      } else {
        revealTargets.forEach(function (el) {
          el.classList.add('is-visible');
        });
      }

      var hero = section.querySelector('.trofeos-hero');
      var stickyBar = section.querySelector('[data-sticky-cta]');
      if (hero && stickyBar && 'IntersectionObserver' in window) {
        var heroObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyBar.hidden = false;
              if (entry.isIntersecting) {
                stickyBar.classList.remove('is-visible');
              } else {
                stickyBar.classList.add('is-visible');
              }
            });
          },
          { threshold: 0 }
        );
        heroObserver.observe(hero);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
